import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/aw-rt.png'


const _withScopeId = n => (_pushScopeId("data-v-a1ec5eda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ArticleDateFilter-title" }
const _hoisted_2 = { class: "ArticleDateFilter-main tstn" }
const _hoisted_3 = { class: "ArticleDateFilter-main-box" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "item-date" }
const _hoisted_6 = { class: "item-num" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_0
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]

import { reactive, onMounted, watch } from 'vue'
import { t } from '@/plugins/i18n'
import { getArchiveDateList } from '@/apis/frog'
import { useSite2Station } from '@/store'


export default /*#__PURE__*/_defineComponent({
  props: {
  dateObj: {
    type: Object,
    default: () => {
      return { frogArticleYear: '', frogArticleMonth: '' }
    }
  }
},
  emits: ['select'],
  setup(__props, { emit: emits }) {

const props = __props
const stationCode = useSite2Station()
const data: any = reactive({
  // 显示更多激活
  isActive: false,
  // 列表
  list: [],
  frogArticleYear: '',
  frogArticleMonth: ''
})



// 显示更多
const showMore = () => {
  data.isActive = !data.isActive
}

onMounted(() => {
  getList()
})

// 获取归档日期列表
const getList = () => {
  getArchiveDateList({ stationCode }).then((res: any) => {
    if (res.code === '0') {
      data.list = res.data
      // data.list.sort((a:any, b:any) => {
      //   return b.frogArticleMonth - a.frogArticleMonth
      // })
    }
  })
}

// 选中item
const selectItem = ({ frogArticleYear, frogArticleMonth }: {frogArticleYear: string, frogArticleMonth: string}) => {
  data.frogArticleYear = frogArticleYear
  data.frogArticleMonth = frogArticleMonth
  emits('select', { frogArticleYear, frogArticleMonth })
}


return (_ctx: any,_cache: any) => {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ArticleDateFilter tstn", { 'active': _unref(data).isActive }])
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('档案')), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_scrollbar, {
        height: _unref(data).isActive ? '456px' : '310px'
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).list, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["ArticleDateFilter-main-item tstn", { 'active': item.frogArticleYear === _unref(data).frogArticleYear && item.frogArticleMonth === _unref(data).frogArticleMonth}]),
                key: index,
                onClick: ($event: any) => (selectItem(item))
              }, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(`${item.frogArticleYear}-${item.frogArticleMonth}`), 1),
                _createElementVNode("div", _hoisted_6, _toDisplayString(item.articleNum), 1)
              ], 10, _hoisted_4))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["height"]),
      (_unref(data).list.length === 0)
        ? (_openBlock(), _createBlock(_component_el_empty, {
            key: 0,
            description: _unref(t)('没有更多了')
          }, null, 8, ["description"]))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "ArticleDateFilter-more",
      onClick: showMore
    }, _hoisted_8, 512), [
      [_vShow, _unref(data).list.length > 8]
    ])
  ], 2))
}
}

})